import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>Privacy Policy</h1>
      
      <section className="privacy-overview">
        <h2>Overview</h2>
        <p>
          At NeuLogic<span style={tmStyle}>™</span>, your privacy is important to us. Our desktop software tools operate locally on your computer and do not collect, transmit, or store your personal information or usage data.
        </p>
      </section>
      
      <section className="privacy-datacollection">
        <h2>Information Collection</h2>
        <p>
          We do not collect personal information from users of our software tools, except as necessary to process purchases or respond to support requests. Any information you provide for purchases or support is kept strictly confidential and never shared with third parties, except as required by law.
        </p>
        <p>
          Our software does not contain tracking mechanisms, analytics tools, or data collection features. Your data remains on your device and under your control at all times.
        </p>
      </section>
      
      <section className="privacy-website">
        <h2>Website Privacy</h2>
        <p>
          Our website may use cookies for basic site functionality, but we do not track your browsing habits or sell your data. If you contact us, your email address will be used only to respond to your inquiry and for no other purpose.
        </p>
      </section>
      
      <section className="privacy-contact">
        <h2>Contact</h2>
        <p>
          For any questions about this policy or our privacy practices, please contact us at <a href="mailto:support@neulogic.tech">support@neulogic.tech</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}